
export const orders = {
  videoRequests: {
    activeRequests: "Aktív videó kérések",
    pastRequests: "Korábbi videó kérések",
    loading: "Betöltés...",
    deadline: "Határidő",
    price: "Ár",
    status: {
      new: "Új",
      accepted: "Folyamatban",
      completed: "Elkészült",
      rejected: "Elutasítva"
    },
    download: "Letöltés",
    noActiveRequests: "Jelenleg nincs aktív videó kérés",
    noPastRequests: "Még nincs korábbi videó kérés"
  },
  questions: {
    title: "Kérdéseim",
    loading: "Kérdések betöltése...",
    noQuestions: "Még nincsenek kérdéseid",
    noQuestionsDescription: "Amikor kérdést küldesz az alkotónak, az itt fog megjelenni",
    askQuestion: "Kérdés feltevése",
    date: "Dátum",
    status: {
      answered: "Megválaszolva",
      pending: "Folyamatban"
    },
    newQuestion: "Új kérdés",
    questionPlaceholder: "Írd ide a kérdésed...",
    send: "Kérdés küldése",
    successToast: {
      title: "Kérdés elküldve",
      description: "A kérdésed sikeresen el lett küldve. A válasz díja 2000 Ft lesz, amit a válasz megtekintéséhez kell kifizetned."
    },
    errorToast: {
      title: "Hiba történt",
      description: "A kérdés küldése nem sikerült, kérjük próbáld újra később."
    },
    continueConversation: "Beszélgetés folytatása (2000 Ft)",
    payForReply: "Fizetés a válaszért (2000 Ft)",
    alreadyPaid: "Már kifizetett"
  },
  filters: {
    title: "Szűrők",
    status: "Státusz",
    allStatuses: "Összes státusz",
    startDate: "Kezdő dátum",
    endDate: "Záró dátum",
    reset: "Szűrők törlése",
    noMatchingOrders: "Nincs a szűrésnek megfelelő megrendelés"
  }
};
